/*
posibles tipos:
- multi
- selector
- listaNumeros
- fecha
- rangoFecha
 */
export default {
  filtrosFijos: [],
  filtrosPorDefecto: [],
  filtrosHabilitados: [
    // { campo: 'DOCNUM', tipo: 'texto', nombre: 'Número Librería' },
    { campo: 'DOCNAME', tipo: 'texto', nombre: 'Nº Documento' },
    { campo: 'EXP_NUM', tipo: 'texto', nombre: 'Nº Expediente' },
    { campo: 'FILENAME', tipo: 'texto', nombre: 'Nombre Archivo' },
    { campo: 'DOCUMENTO_MADRE', tipo: 'texto', nombre: 'Nº Doc. madre' },
    { campo: 'FOLIO', tipo: 'texto', nombre: 'Nº Folio' },
    {
      campo: 'ID',
      tipo: 'selector-empresa',
      nombre: 'Empresa',
      opciones: [
        { label: 'AA', id: 'AA' },
        { label: 'AC', id: 'AC' },
        { label: 'AM', id: 'AM' }
      ]
    },
    {
      campo: 'TYPE_ID',
      nombre: 'Tipo Documento',
      tipo: 'selector-doc',
      opciones: [
        { label: 'Carta', id: 'CARTA' },
        { label: 'DFL', id: 'DFL' },
        { label: 'LEY-REG', id: 'LEY-REG' },
        { label: 'Normas', id: 'NORMAS' },
        { label: 'ORD', id: 'ORD' },
        { label: 'RE', id: 'RE' },
        { label: 'DE-REG', id: 'DE-REG' },
        { label: 'Ficha', id: 'FICHA' },
        { label: 'Anexo', id: 'ANEXO' }
      ]
    },
    {
      campo: 'ID_AUTOR',
      tipo: 'selector-autor',
      nombre: 'Autor',
      opciones: [
        { label: 'SISS', id: 'SISS' },
        { label: 'AA', id: 'AA' },
        { label: 'AC', id: 'AC' },
        { label: 'AM', id: 'AM' },
        { label: 'INN', id: 'INN' },
        { label: 'MIN', id: 'MIN' }
      ]
    },
    {
      campo: 'ID_TEMA',
      tipo: 'selector-tema',
      nombre: 'Tema',
      opciones: [
        { label: 'Agua Potable Ap', id: 'Agua_Potable_AP' },
        { label: 'Informativo', id: 'Informativo' },
        { label: 'Aguas Servidas', id: 'Aguas_Servidas' },
        { label: 'Nuevos Servicios', id: 'Nuevos_Servicios' },
        { label: 'Fiscalización', id: 'Fiscalización' },
        { label: 'Planes de Desarrollo', id: 'Planes_de_Desarrollo' },
        { label: 'Proceso de Sanción', id: 'Proceso_de_Sanción' },
        { label: 'Leyes y Normas', id: 'Leyes y Normas' },
        { label: 'Protocolo', id: 'Protocolo' },
        { label: 'SAC', id: 'SAC' },
        { label: 'Tarifas', id: 'Tarifas' },
        { label: 'Emergencia', id: 'Emergencia' },
        { label: 'Compras', id: 'Compras' },
        { label: 'Medio Ambiente', id: 'Medio_Ambiente' },
        { label: 'Norma', id: 'Norma' },
        { label: 'DFL', id: 'DFL' }
      ]
    },
    {
      campo: 'ID_SUBTEMA',
      tipo: 'selector-subtema',
      nombre: 'SubTema',
      opciones: [
        { label: 'Calidad AP', id: 'Calidad AP' },
        { label: 'Déficit Hídrico', id: 'Déficit Hídrico' },
        { label: 'Redes AP', id: 'Redes AP' },
        { label: 'Presión', id: 'Presión' },
        { label: 'Fuentes', id: 'Fuentes' },
        { label: 'Grifos', id: 'Grifos' },
        { label: 'Medición', id: 'Medición' },
        { label: 'Producción', id: 'Producción' },
        { label: 'PTAP', id: 'PTAP' },
        { label: 'Informativo', id: 'Informativo' },
        { label: 'Instructivo', id: 'Instructivo' },
        { label: 'By Pass', id: 'By Pass' },
        { label: 'Redes AS', id: 'Redes AS' },
        { label: 'PTAS', id: 'PTAS' },
        { label: 'Plan de Invierno', id: 'Plan De Invierno' },
        { label: 'Riles', id: 'Riles' },
        { label: 'Calidad AS', id: 'Calidad AS' },
        { label: 'Aguas Grises', id: 'Aguas Grises' },
        { label: 'Factibilidad', id: 'Factibilidad' },
        { label: 'Ampliación de concesión', id: 'Ampliación de concesión' },
        { label: 'Fiscalización', id: 'Fiscalización' },
        { label: 'Planes de Desarrollo', id: 'Planes de Desarrollo' },
        { label: 'Ampliación de Concesión', id: 'Ampliacion de Concesion' },
        { label: 'Obras', id: 'Obras' },
        { label: 'Proceso de Sanción', id: 'Proceso_de_Sanción' },
        { label: 'Servicios Sanitarios', id: 'Servicios Sanitarios' },
        { label: 'Sociedades de Servicios Sanitarios', id: 'Sociedades de Servicios Sanitarios' },
        { label: 'Protocolo', id: 'Protocolo' },
        { label: 'Facturación', id: 'Facturación' },
        { label: 'Comercial', id: 'Comercial' },
        { label: 'Cov19', id: 'Cov19' },
        { label: 'Tarifas', id: 'Tarifas' },
        { label: 'Emergencia', id: 'Emergencia' },
        { label: 'Licitación', id: 'Licitación' },
        { label: 'Contratos', id: 'Contratos' },
        { label: 'Empresas Relacionadas', id: 'Empresas Relacionadas' },
        { label: 'Servidumbre', id: 'Servidumbre' },
        { label: 'Medio Ambiente', id: 'Medio_Ambiente' },
        { label: 'Reglamento', id: 'Reglamento' },
        { label: 'Norma', id: 'Norma' },
        { label: 'NCh-ISO', id: 'NCh-ISO' },
        { label: 'DFL', id: 'DFL' }
      ]
    },
    { campo: 'MATERIA_REG', tipo: 'texto', nombre: 'Materia' },
    {
      campo: 'CAMPO48', tipo: 'fecha', nombre: 'Fecha de Documento', valor: ''
    }
  ]
};
